import React from "react";
import { Avatar, Button, Stack, Typography } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";

// Used Button instead of IconButton
// Background color is #A50034

const AccountMenuButton = ({ label, avatarImage, isDropdown, onClick }) => {
  return (
    <Button variant="contained"
            onClick={onClick}
            style={{ backgroundColor: "#a50034", borderRadius: "0.5rem" }}>
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Typography>{label}</Typography>
        <Avatar
          sx={{
            width: 30,
            height: 30,
            color: "#a50034",
            backgroundColor: "#fff"
          }}
        >
          {avatarImage}
        </Avatar>
        {isDropdown && <ExpandMore style={{ margin: 0 }} />}
      </Stack>
    </Button>
  );
};

export default AccountMenuButton;
